<template>
  <div
    :style="styles"
    class="rt-advance-table-item"
  >
    <div class="rt-advance-table-item-content">
      <rt-checkbox
        v-if="showCheck"
        v-bind="$attrs"
        @change="handleChange"
      >
        <slot />
      </rt-checkbox>
      <slot v-else />
    </div>
  </div>
</template>

<script>
import RtCheckbox from '../checkbox/rtCheckbox.vue'
export default {
  name: 'RtAdvanceTableItem',
  inject: ['col'],
  components: {
    RtCheckbox
  },
  props: {
    showCheck: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    styles () {
      let pre = (1 / this.col) * 100;
      return {
        width: `calc(${pre}% )`
      };
    }
  },
  methods: {
    handleChange (val) {
      this.$emit('change', val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtAdvanceTableItem.vue?1d5e0f76